import { cn } from "@/lib/utils";

interface PixelButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: "primary" | "outline";
  size?: "default" | "lg";
}

export function PixelButton({
  children,
  className,
  variant = "primary",
  size = "default",
  ...props
}: PixelButtonProps) {
  return (
    <button
      className={cn(
        "font-pixel transition-transform active:scale-95 pixel-corners",
        variant === "primary"
          ? "bg-primary text-primary-foreground hover:bg-primary/90"
          : "border-2 border-primary bg-transparent text-primary hover:bg-primary/10",
        size === "lg" ? "h-14 px-8 text-sm" : "h-12 px-6 text-xs",
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}
